import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/article/page";
import ShoppingGuide from "../pages/article/shopping-guide/page";
import GenericArticle from "../pages/article/generic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/superbuy-shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/superbuy-safety-review",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-vs-agents",
    element: <GenericArticle />,
  },
  {
    path: "/best-superbuy-finds-2026",
    element: <GenericArticle />,
  },
  {
    path: "/how-to-order-superbuy",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-shipping-guide",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-qc-guide",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-payment-guide",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-streetwear-finds",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-sneaker-spreadsheet",
    element: <GenericArticle />,
  },
  {
    path: "/superbuy-hidden-gems",
    element: <GenericArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;